import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector, useDispatch } from 'react-redux';
import { Filter } from '../../components/lister/filters/Filter';
import { filterActions } from '../../redux/filter/actions/FilterActions.creators';
import { basketActions } from '../../redux/basket/actions/BasketActions.creators';
import { makeGetActiveFiltersState, makeGetEnabledFiltersState, makeGetItemCount, makeGetfredhopperGlossaryState, makeGetFilterWizardState, makeGetInStoreFilterState, } from '../../redux/lister/selectors/ListerSelector';
import { makeGetStoreId, makeGetUrlFilters } from '../../redux/url/selectors/UrlSelectors';
import { urlActions } from '../../redux/url/actions/UrlActions.creators';
import { listerActions } from '../../redux/lister/actions/ListerActions.creators';
import { analyticsActions } from '../../redux/analytics/actions/AnalyticsActions.creators';
import { makeGetBasketCCPopupState } from '../../redux/basket/selectors/BasketSelector';
export const FilterContainer = ({ showInStoreFilter, isBrandPage = false }) => {
    const dispatch = useDispatch();
    const onFilterItemChange = (toggledFilter) => dispatch(filterActions.updateFilters(toggledFilter));
    const removeAllFilters = () => dispatch(filterActions.removeAllFilters());
    const updateInStoreFilter = (inStoreFilter) => dispatch(listerActions.updateInStoreFilter(inStoreFilter));
    const itemCount = useSelector(makeGetItemCount());
    const filters = useSelector(makeGetEnabledFiltersState(isBrandPage));
    const filterWizardConfig = useSelector(makeGetFilterWizardState());
    const activeFilters = useSelector(makeGetActiveFiltersState());
    const fredhopperGlossary = useSelector(makeGetfredhopperGlossaryState());
    const urlFilters = useSelector(makeGetUrlFilters());
    const inStoreFilter = useSelector(makeGetInStoreFilterState());
    const activeStoreId = useSelector(makeGetStoreId());
    const { collapsed } = useSelector(makeGetBasketCCPopupState());
    const openInStoreFilterPopup = () => {
        dispatch(basketActions.createCCPopupOpenAction());
        if (!inStoreFilter) {
            dispatch(analyticsActions.storeFilterStarted());
        }
        else {
            dispatch(analyticsActions.storeFilterModified());
        }
    };
    const updateStoreId = (storeId) => {
        dispatch(urlActions.updateStoreId(storeId));
        if (!storeId) {
            dispatch(basketActions.createCCPopupOpenAction());
            dispatch(analyticsActions.storeFilterStarted());
        }
        else if (!activeStoreId) {
            dispatch(analyticsActions.storeFilterApplied());
        }
    };
    return (_jsx(Filter, { filters: filters, activeFilters: activeFilters, itemCount: itemCount, fredhopperGlossary: fredhopperGlossary, filterWizardConfig: filterWizardConfig, removeAllFilters: removeAllFilters, onFilterItemChange: onFilterItemChange, urlFilters: urlFilters, ccPopupCollapsed: collapsed, storeOptions: {
            inStoreFilter,
            activeStoreId,
            showInStoreFilter,
            updateInStoreFilter,
            updateStoreId,
            openInStoreFilterPopup,
        } }));
};
